/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Emoji_DamagedInputs */



/**
* | output |
* | --- |
* | "[DAMAGED]" |
*
* @param {Error_Emoji_DamagedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_emoji_damaged = /** @type {((inputs?: Error_Emoji_DamagedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Emoji_DamagedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("[BESCHÄDIGT]")
	if (locale === "fr") return /** @type {LocalizedString} */ ("[ENDOMMAGÉE]")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("[破损]")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("[破損]")
	if (locale === "ko") return /** @type {LocalizedString} */ ("[손상]")
	return /** @type {LocalizedString} */ ("[DAMAGED]")
});